import {
  CALENDARIO_INICIA,
  CALENDARIO_NOVO,
  CALENDARIO_SALVA,
  CALENDARIO_SALVA_SUCESSO,
  CALENDARIO_BUSCA_EDICAO,
  CALENDARIO_BUSCA_EDICAO_SUCESSO,
  CALENDARIO_LISTA_TODOS,
  CALENDARIO_LISTA_TODOS_SUCESSO,
  CALENDARIO_LISTA_ESCOLAS,
  CALENDARIO_LISTA_ESCOLAS_SUCESSO,
  CALENDARIO_CARREGA_DIAS,
  CALENDARIO_CARREGA_DIAS_SUCESSO,
  CALENDARIO_CARREGA_TIPOS_EVENTO,
  CALENDARIO_CARREGA_TIPOS_EVENTO_SUCESSO,
  CALENDARIO_LISTA_TURMAS,
  CALENDARIO_LISTA_TURMAS_SUCESSO,
  CALENDARIO_SALVA_ANOTACAO,
  CALENDARIO_SALVA_ANOTACAO_SUCESSO,
  CALENDARIO_REMOVE_ANOTACAO,
  CALENDARIO_REMOVE_ANOTACAO_SUCESSO,
  CALENDARIO_SALVA_EVENTO_DIA,
  CALENDARIO_SALVA_EVENTO_DIA_SUCESSO,
  CALENDARIO_REMOVE_EVENTO_DIA,
  CALENDARIO_REMOVE_EVENTO_DIA_SUCESSO,
  CALENDARIO_LIMPAR,
  CALENDARIO_ERRO,
  CALENDARIO_SELECIONA_DIA
} from 'constants/CalendarioTypes';

export const iniciaCalendario = () => {
  return {
    type: CALENDARIO_INICIA
  };
};

export const listaCalendarios = (escolaId) => {
  return {
    type: CALENDARIO_LISTA_TODOS,
    payload: escolaId
  };
};

export const listaCalendariosSucesso = (calendarios) => {
  return {
    type: CALENDARIO_LISTA_TODOS_SUCESSO,
    payload: calendarios
  };
};

export const listaEscolas = () => {
  return {
    type: CALENDARIO_LISTA_ESCOLAS
  };
};

export const listaEscolasSucesso = (escolas) => {
  return {
    type: CALENDARIO_LISTA_ESCOLAS_SUCESSO,
    payload: escolas
  };
};

export const novoCalendario = () => {
  return {
    type: CALENDARIO_NOVO
  };
};

export const salvaCalendario = (calendario) => {
  return {
    type: CALENDARIO_SALVA,
    payload: calendario
  };
};

export const salvaCalendarioSucesso = (calendario) => {
  return {
    type: CALENDARIO_SALVA_SUCESSO,
    payload: calendario
  };
};

export const buscaCalendarioEdicao = (id) => {
  return {
    type: CALENDARIO_BUSCA_EDICAO,
    payload: id
  };
};

export const buscaCalendarioEdicaoSucesso = (calendario) => {
  return {
    type: CALENDARIO_BUSCA_EDICAO_SUCESSO,
    payload: calendario
  };
};

export const carregaDiasCalendario = (calendarioId, ano) => {
  return {
    type: CALENDARIO_CARREGA_DIAS,
    payload: { calendarioId, ano }
  };
};

export const carregaDiasCalendarioSucesso = (dias) => {
  return {
    type: CALENDARIO_CARREGA_DIAS_SUCESSO,
    payload: dias
  };
};

export const carregaTiposEvento = (escolaId) => {
  return {
    type: CALENDARIO_CARREGA_TIPOS_EVENTO,
    payload: escolaId
  };
};

export const carregaTiposEventoSucesso = (tipos) => {
  return {
    type: CALENDARIO_CARREGA_TIPOS_EVENTO_SUCESSO,
    payload: tipos
  };
};

export const listaTurmas = (escolaId) => {
  return {
    type: CALENDARIO_LISTA_TURMAS,
    payload: escolaId
  };
};

export const listaTurmasSucesso = (turmas) => {
  return {
    type: CALENDARIO_LISTA_TURMAS_SUCESSO,
    payload: turmas
  };
};

export const salvaAnotacao = (anotacao) => {
  return {
    type: CALENDARIO_SALVA_ANOTACAO,
    payload: anotacao
  };
};

export const salvaAnotacaoSucesso = (anotacao) => {
  return {
    type: CALENDARIO_SALVA_ANOTACAO_SUCESSO,
    payload: anotacao
  };
};

export const removeAnotacao = (id) => {
  return {
    type: CALENDARIO_REMOVE_ANOTACAO,
    payload: id
  };
};

export const removeAnotacaoSucesso = (id) => {
  return {
    type: CALENDARIO_REMOVE_ANOTACAO_SUCESSO,
    payload: id
  };
};

export const salvaEventoDia = (evento) => {
  return {
    type: CALENDARIO_SALVA_EVENTO_DIA,
    payload: evento
  };
};

export const salvaEventoDiaSucesso = (evento) => {
  return {
    type: CALENDARIO_SALVA_EVENTO_DIA_SUCESSO,
    payload: evento
  };
};

export const removeEventoDia = (id) => {
  return {
    type: CALENDARIO_REMOVE_EVENTO_DIA,
    payload: id
  };
};

export const removeEventoDiaSucesso = (id) => {
  return {
    type: CALENDARIO_REMOVE_EVENTO_DIA_SUCESSO,
    payload: id
  };
};

export const selecionaDia = (data) => {
  return {
    type: CALENDARIO_SELECIONA_DIA,
    payload: data
  };
};

export const limparCalendario = () => {
  return {
    type: CALENDARIO_LIMPAR
  };
};

export const calendarioErro = (erro) => {
  return {
    type: CALENDARIO_ERRO,
    payload: erro
  };
};
